/**
 * Le Vanilla + Map default layout — same primitives as Le Vanilla plus a
 * RouteMap that lives in the new `map` slot. The shell renders both `player`
 * and `map` slots inside the surface and toggles which is visible.
 */

import type { Layout } from '../../layout'

export const LE_VANILLA_MAP_DEFAULT_LAYOUT: Layout = {
  version: 1,
  shell: 'le_vanilla_map',
  slots: {
    topbar: [{ id: 'topbar', primitive: 'Topbar', config: {} }],
    player: [{ id: 'player', primitive: 'PrimaryView', config: {} }],
    map: [{ id: 'map', primitive: 'RouteMap', config: { basemap: 'satellite' } }],
    player_overlay: [
      { id: 'player-clean-view', primitive: 'CleanViewButton', config: {} },
      { id: 'player-fullscreen', primitive: 'FullscreenButton', config: {} },
    ],
    below_player: [
      { id: 'title', primitive: 'EventTitle', config: {} },
      { id: 'producer', primitive: 'ProducerRow', config: { showFollow: true } },
      { id: 'engagement', primitive: 'EngagementCluster', config: {} },
      { id: 'description', primitive: 'EventDescription', config: {} },
    ],
    sidebar: [
      { id: 'rail', primitive: 'CameraRail', config: { sortBy: 'position' } },
      { id: 'sponsor', primitive: 'SponsorLockup', config: {} },
      { id: 'leaders', primitive: 'ResultsView', config: {} },
    ],
    mobile_switcher: [
      {
        id: 'mms',
        primitive: 'ViewSwitcher',
        config: { modes: ['about', 'cameras', 'map'], defaultMode: 'about' },
      },
    ],
  },
}
